export enum Route {
  ADD_MOBILE = '/add-mobile',
  ADD_PAYMENT_METHOD = '/add-payment-method',
  // Apple Pay Later flow-specific routes (no base equivalents)
  ADJUST_AMOUNT = '/apple-paylater/adjust-amount',
  APPLE_PAYLATER_ADD_CARD = '/apple-paylater/add-card',
  APPLE_PAYLATER_INITIALISE = '/apple-paylater/initialise',
  APPLE_PAYLATER_INITIAL_LOADING = '/apple-paylater/initial-loading',
  CARD_EDUCATION = '/apple-paylater/card-education',
  CASH_AUTH = '/cash-auth',
  CASH_AUTH_INLINE = '/cash-auth-inline',
  CREATE_PASSWORD = '/create-password',
  ENTER_EMAIL = '/login',
  ENTER_PASSWORD = '/password',
  NEW_PAYMENT_METHOD = '/new-payment-method',
  NEW_SHIPPING_ADDRESS = '/new-shipping-address',
  EDIT_SHIPPING_ADDRESS = '/edit-shipping-address',
  EDIT_SHIPPING_ADDRESS_WITH_ID = '/edit-shipping-address/[id]',
  ONE_TIME_PASSWORD = '/login-one-time-code',
  PAY = '/pay',
  PAY_MONTHLY = '/pay-monthly',
  PAY_MONTHLY_ONLY = '/pay-monthly-only',
  PAYMENT_METHOD = '/payment-method',
  PAYMENT_OPTIONS = '/payment-options',
  PAYMENT_TYPES = '/payment-types',
  PREFERRED_PAYMENT_DAY = '/preferred-payment-day',
  LOGGED_IN = '/logged-in',
  SHIPPING_ADDRESS = '/shipping-address',
  SIGN_UP = '/sign-up',
  SUMMARY = '/summary',
  TERMINAL_ERROR = '/oh-no',
  VERIFY = '/verify',
  VERIFY_CHALLENGE = '/verify-challenge',
  VERIFY_IDENTITY = '/verify-identity',
  VERIFY_LICENCE = '/verify-identity/licence',
  VERIFY_MEDICARE = '/verify-identity/medicare',
  VERIFY_PASSPORT = '/verify-identity/passport',
  VERIFY_ADDRESS = '/verify-identity/address',
  VERIFY_BIOMETRIC_LICENCE = '/verify-identity/biometric/licence',
  VERIFY_BIOMETRIC_PASSPORT = '/verify-identity/biometric/passport',
  VERIFYING_BIOMETRIC = '/verify-identity/biometric/verifying',
  VERIFY_BIOMETRIC_PERSONA = '/verify-identity/biometric/persona',
  VERIFY_IDENTITY_START = '/verify-identity-start',
  RETRY_VERIFY_LICENCE = '/verify-identity/retry/licence',
  RETRY_VERIFY_PASSPORT = '/verify-identity/retry/passport',
  RETRY_VERIFY_MEDICARE = '/verify-identity/retry/medicare', // only being used in unit test
  VERIFY_RETRY = '/verify-retry',
  CARD_SCAN = '/card-scan',
  PASSWORD_RESET_REQUIRED = '/password-reset-required',
  AMOUNT_TOO_HIGH = '/oh-no/amount_too_high',
  ORDER_LIMIT_EXCEEDED = '/oh-no/max_active_orders_reached',
  OVERDUE_PAYMENTS_CHECKOUT_PAYMENT_ELIGIBLE = '/oh-no/overdue_payments_checkout_payment_eligible',
  RETRY_CREDIT_FREEZE = '/retry-credit-freeze',
  INDEX = '/',
  INITIAL_LOADING = '/initial-loading',
  KYC_CONFIRM_DETAILS = '/kyc-profile-confirm-details',
  KYC_UPDATE_ADDRESS = '/kyc-profile-confirm-details/update-address',
  UNSUITABILITY_QUESTION_FORM = '/unsuitability-questions/form',
  AFFORDABILITY_QUESTION_FORM = '/affordability-questions/form',
  GET_STARTED = '/onboarding/get-started',
  CONTRACT_AGREEMENT = '/contract-agreement',
  EDUCATION_INTRO = '/education-intro',
  PURCHASE_SUCCESS = '/purchase-success',
  PROFILE_CREATED = '/profile-created',
  WELCOME_WITH_INITIAL_LIMIT = '/welcome-with-initial-limit',
}

export const isRoute = (a: unknown): a is Route => Object.values(Route).includes(a as Route)
